import '../css/app.css';
import './bootstrap';
import axios from 'axios';
import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createI18n } from 'vue-i18n';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import MainLayout from './Layouts/MainLayout.vue';
import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import language files
import en from '../langs/en.json';
import fr from '../langs/fr.json';

window.axios = axios;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

// Get CSRF token from meta tag and set it for axios
function setCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (token) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
    }
}

// Initial CSRF token setup
setCsrfToken();

// Function to apply the theme
const applyTheme = () => {
    const savedTheme = localStorage.getItem('theme') || 'dark';
    if (savedTheme === 'dark') {
        document.documentElement.classList.add('dark');
    } else {
        document.documentElement.classList.remove('dark');
    }
};

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Set up i18n
const i18n = createI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: {
        en,
        fr,
    },
});

// Refresh CSRF token after each Inertia request
router.on('success', (event) => {
    // Update the CSRF token in the meta tag if provided in response
    const { props } = event.detail.page;
    if (props.csrf_token) {
        const metaTag = document.querySelector('meta[name="csrf-token"]');
        if (metaTag) {
            metaTag.setAttribute('content', props.csrf_token);
            axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrf_token;
        }
    }
});

let appInstance = null;
function initializeApp() {
    if (appInstance) {
        console.warn('App already mounted, skipping initialization');
        return;
    }

    createInertiaApp({
        title: (title) => `${title} - ${appName}`,
        resolve: (name) =>
            resolvePageComponent(
                `./Pages/${name}.vue`,
                import.meta.glob('./Pages/**/*.vue'),
            ).then((module) => {
                module.default.layout = module.default.layout || MainLayout;
                return module;
            }),
        setup({ el, App, props, plugin }) {
            appInstance = createApp({ render: () => h(App, props) })
                .use(plugin)
                .use(ZiggyVue)
                .use(i18n)
                .mount(el);

            return appInstance;
        },
        progress: {
            color: '#4B5563',
        },
    }).catch(error => {
        console.error('Failed to initialize Inertia app:', error);
    });
}

applyTheme();
initializeApp();